import React, {useState} from 'react';
import {Button, Modal, Row, Spin} from "antd";
import '../modals.css';
import {Redirect} from "react-router-dom";
import i18n from '../../../i18n';

export default function ModalNeedApprovedLegalEntity({isShow, setIsShow, text, title = i18n.t('modals.modalNeedApprovedLegalEntity.titles.default')}) {

  const [loading, setLoading] = useState(false);
  const [redirectToLegalEntities, setRedirectToLegalEntities] = useState(false);

  let bigButtonStyle = {
    width: '190px',
    height: '40px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    borderColor: "#1CAA53"
  };

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };


  const redirect = () => {
    setRedirectToLegalEntities(true);
  };

  if (redirectToLegalEntities) {
    return (<Redirect to="/company/legal-entities" push={true}/>)
  }

  return (
    <Modal
      title={<span className="ant-modal-title">{title}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={[
        <Button htmlType="submit" style={bigButtonStyle} key="submit" type="primary" onClick={() => {
          redirect()
        }}>{i18n.t('modals.modalNeedApprovedLegalEntity.link')}</Button>,
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row className="add-padding-10 -centered">
          <h2 style={textStyle}>{text}</h2>
        </Row>
      </Spin>
    </Modal>
  );
}
